// =============================================================================
// DATA / FLORISTS.JS — Calgary florists (most travel to Canmore & Banff)
// Field order: Style → Services → Pricing → Consultations → Travel → Booking → Note → Email → Instagram → Website
// =============================================================================

export const floristData = [
  { name: "Small Flower", tier: "$", fields: [
    { label: "Style", value: "English Country Garden — lush, whimsical; locally grown Alberta blooms" },
    { label: "Services", value: "Full service; à la carte menu available" },
    { label: "Pricing", value: "À la carte from under $2,500; full service custom quoted" },
    { label: "Travel", value: "Calgary, Canmore, Banff & surrounding mountain venues" },
    { label: "Booking", value: "3+ months recommended" },
    { label: "Email", value: "flowers@smallflower.ca" },
    { label: "Instagram", value: "@smallflowerfloralstudio" },
    { label: "Website", value: "smallflower.ca", link: "https://www.smallflower.ca" },
  ]},
  { name: "Creative Edge Flowers", tier: "$", fields: [
    { label: "Style", value: "Modern to classic — adaptable to any aesthetic" },
    { label: "Services", value: "Full service including large installations" },
    { label: "Pricing", value: "No minimum spend" },
    { label: "Consultations", value: "Free phone/email; in-person $75 deposit (credited at booking)" },
    { label: "Travel", value: "Calgary, Canmore, Banff & further" },
    { label: "Booking", value: "Flexible — can accommodate last-minute elopements" },
    { label: "Email", value: "justine@creativeedgeflowers.com" },
    { label: "Instagram", value: "@creativeedgeflowersyyc" },
    { label: "Website", value: "creativeedgeflowers.com", link: "https://www.creativeedgeflowers.com" },
  ]},
  { name: "Flower Chix", tier: "$/$$", fields: [
    { label: "Style", value: "All styles — lush/romantic, minimalist, wildflower, modern, classic" },
    { label: "Services", value: "Full service including delivery and on-site setup" },
    { label: "Travel", value: "Calgary, Canmore & Banff — delivery fee applies" },
    { label: "Booking", value: "Earlier is better; can sometimes accommodate short notice" },
    { label: "Email", value: "info@flowerchix.ca" },
    { label: "Instagram", value: "@flowerchixyyc" },
    { label: "Website", value: "flowerchix.com", link: "https://www.flowerchix.com" },
  ]},
  { name: "Calyx Floral Design", tier: "$/$$", fields: [
    { label: "Style", value: "Flower-forward, lush and romantic; large-scale installations a specialty" },
    { label: "Services", value: "Full service — bouquets, centrepieces, ceremony, reception, installations" },
    { label: "Pricing", value: "No minimum spend" },
    { label: "Travel", value: "Calgary, Canmore & Banff — experienced at mountain venues" },
    { label: "Note", value: "Preferred florist at Calgary Marriott Downtown" },
    { label: "Email", value: "hello@calyxfloraldesign.ca" },
    { label: "Instagram", value: "@calyxfloraldesign" },
    { label: "Website", value: "calyxfloraldesign.ca", link: "https://calyxfloraldesign.ca" },
  ]},
  { name: "The Romantiks", tier: "$/$$", fields: [
    { label: "Style", value: "Lush, organic, romantic — unique designs for each couple" },
    { label: "Services", value: "Full service including custom installations" },
    { label: "Pricing", value: "$2,500 minimum during peak season (May–November)" },
    { label: "Travel", value: "Canmore, Banff, Lake Louise & beyond" },
    { label: "Booking", value: "6+ months recommended" },
    { label: "Email", value: "theromantiks@gmail.com" },
    { label: "Instagram", value: "@the.romantiks" },
    { label: "Website", value: "theromantiks.com", link: "https://www.theromantiks.com" },
  ]},
  { name: "Jarman Flower Shop", tier: "$/$$", fields: [
    { label: "Style", value: "Modern, design-driven, refined — no two weddings the same" },
    { label: "Services", value: "Full service including large-scale installations" },
    { label: "Pricing", value: "No minimum in Calgary; $2,500 minimum for Canmore/Banff" },
    { label: "Travel", value: "Calgary, Canmore & Banff" },
    { label: "Booking", value: "3–6 months recommended" },
    { label: "Email", value: "info@jarmanshop.com" },
    { label: "Instagram", value: "@jarmanshop" },
    { label: "Website", value: "jarmanshop.com", link: "https://jarmanshop.com" },
  ]},
  { name: "Adventure Floral", tier: "$", fields: [
    { label: "Style", value: "Organic, whimsical, nature-inspired — perfect for mountain and outdoor settings" },
    { label: "Services", value: "Full service and partial service; studio pickup also available — whatever works best for the couple" },
    { label: "Pricing", value: "No minimum spend; elopement florals available when paired with other same-date weddings" },
    { label: "Consultations", value: "Phone consults or in-person at a Calgary coffee shop" },
    { label: "Travel", value: "Canmore, Banff & surrounding areas — approximately 90% of weddings are in Canmore" },
    { label: "Booking", value: "Minimum 3 weeks notice to guarantee flower availability; bookings accepted up to a year in advance" },
    { label: "Instagram", value: "@adventurefloral" },
    { label: "Website", value: "adventurefloral.ca", link: "https://www.adventurefloral.ca" },
  ]},
  { name: "Among the Wildflwrs", tier: "$$/$$$ ", fields: [
    { label: "Style", value: "Refined garden-inspired — lush romantic textures, organic editorial feel" },
    { label: "Services", value: "Full service; selective à la carte bookings" },
    { label: "Pricing", value: "From $3,500–$5,000; most couples invest $5,000–$8,000+" },
    { label: "Consultations", value: "Complimentary consultations offered" },
    { label: "Travel", value: "Calgary, Canmore, Banff & surrounding areas" },
    { label: "Booking", value: "6–12+ months recommended for peak season" },
    { label: "Instagram", value: "@amongthewldflwrs" },
    { label: "Website", value: "amongthewldflwrs.com", link: "https://www.amongthewldflwrs.com" },
  ]},
];


export const floristPending = ["Flower Aura by Natasha", "Kensington Florist", "Pine for Cedar", "Le Bouquet Floral", "Flower Artistry", "Black Earth Floral", "Flowers by Janie", "Flower Culture YYC", "La Maison Flower Studio", "Callia Florals", "Blue Lakes Floral Design"];
